// App store URLs — replace with real URLs once the apps are published
export const APP_STORE_URLS = {
  appStore: 'https://apps.apple.com/app/tournaly/id000000000',
  googlePlay: 'https://play.google.com/store/apps/details?id=com.tournaly.app',
};
